<template>
  <div class="page-container capiital-info">
    <div class="main">
      <el-card shadow="never" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>{{ $t('text.myFund') }}</span>
        </div>
        <el-row class="my-fund-total" type="flex" align="middle" justify="center">
          <el-col :span="6" class="colStyle">
            <div>{{ $t('text.pendingSettlement') }}</div>
            <div>{{ waitSettleAmountView }}</div>
          </el-col>
          <el-col :span="6"
                  class="colStyle"
                  v-if="ROLE_TYPE.isAgent()">
            <div>{{ $t('text.agentBalance') }}</div>
            <div>{{ balanceView }}</div>
          </el-col>
          <el-col :span="6"
                  class="colStyle"
                  v-if="ROLE_TYPE.isMerchant()">
            <div>{{ $t('message.balance') }}</div>
            <div>{{ balanceView }}</div>
          </el-col>
          <el-col :span="6" class="colStyle">
            <div>{{ $t('text.frozenAmount') }}</div>
            <div>{{ freezeBalanceView }}</div>
          </el-col>
          <el-col :span="6" class="colStyle">
            <div>{{ $t('message.availableBalance') }}</div>
            <div>{{ availableBalanceView }}</div>
          </el-col>
          <el-col :span="6" class="colStyle" v-if="ROLE_TYPE.isMerchant()">
            <div>{{ $t('text.creditAvailableAmount') }}</div>
            <div>{{ creditAvailableAmountView }}</div>
          </el-col>
          <el-col :span="6" class="colStyle">
            <div>{{ $t('text.creditGrantedAmount') }}</div>
            <div>{{ creditQuotaView }}</div>
          </el-col>
          <el-col :span="6" class="colStyle" v-if="ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()">
            <div>{{ $t('text.creditMerchantCount') }}</div>
            <div>{{ creditMerchantCountView }}</div>
          </el-col>
          <el-col class="my-fund-button" :span="6">
            <el-button :loading="loading"
                       type="primary"
                       size="mini"
                       @click="handleRefresh">
              {{ $t('text.refresh') }}
            </el-button>
            <br/>
            <template v-if="ROLE_TYPE.isMerchant()">
              <el-button type="primary"
                         size="mini"
                         plain
                         style="margin-top: 10px"
                         @click="handleRecharge">
                {{ $t('text.recharge') }}
              </el-button>
              <el-button type="primary"
                         size="mini"
                         plain
                         style="margin-top: 10px"
                         v-if="ROLE_TYPE.isEnabledCredit()"
                         @click="handleCredit">
                {{ $t('text.payinCredit') }}
              </el-button>
              <br/>
              <el-button type="warning"
                         size="mini"
                         @click="handleWithdraw"
                         plain
                         style="margin-top: 10px">
                {{ $t('text.withdrawal') }}
              </el-button>
              <br/>
            </template>
            <template v-if="ROLE_TYPE.isAgent()">
              <el-button type="primary"
                         size="mini"
                         plain
                         style="margin-top: 10px"
                         @click="handleRecharge">
                {{ $t('text.recharge') }}
              </el-button>
              <br/>
              <el-button type="warning"
                         size="mini"
                         @click="handleWithdraw"
                         plain
                         style="margin-top: 10px">
                {{ $t('text.withdrawal') }}
              </el-button>
              <br/>
            </template>
            <template v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isBusinessCustomerServiceManage()">
              <el-button type="primary"
                         size="mini"
                         @click="handleAddRechargeWithdraw('00')"
                         plain
                         style="margin-top: 10px">
                {{ $t('text.credit') }}
              </el-button>
              <el-button type="primary"
                         size="mini"
                         @click="handleAddTrans"
                         plain
                         style="margin-top: 10px">
                {{ $t('text.transfer') }}
              </el-button>
              <br/>
              <el-button type="warning"
                         size="mini"
                         @click="handleAddRechargeWithdraw('01')"
                         plain
                         style="margin-top: 10px">
                {{ $t('text.debit') }}
              </el-button>
            </template>
          </el-col>
        </el-row>
      </el-card>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('text.rechargeRecords')" name="recharge">
          <MerchantRecharge v-if="ROLE_TYPE.isMerchant()"/>
          <PlatformRecharge v-else :fromMerchantList="merchantList"/>
        </el-tab-pane>

        <el-tab-pane :label="$t('text.withdrawalRecords')" name="withdraw">
          <MerchantWithdraw v-if="ROLE_TYPE.isMerchant()"/>
          <PlatformWithdraw v-else :fromMerchantList="merchantList"/>
        </el-tab-pane>

        <el-tab-pane :label="$t('text.creditRecords')" name="credit" v-if="!ROLE_TYPE.isMerchantStaff()">
          <MerchantCredit v-if="ROLE_TYPE.isMerchant()"/>
          <PlatformCredit v-else :fromMerchantList="merchantList"/>
        </el-tab-pane>

        <el-tab-pane :label="$t('text.reductionRecords')" name="reduction">
          <MerchantReduction v-if="ROLE_TYPE.isMerchant()"/>
          <PlatformReduction v-else :fromMerchantList="merchantList"/>
        </el-tab-pane>

        <el-tab-pane :label="$t('text.pendingSettlement')" name="waitSettleAmount">
          <PlatformWaitSettle :fromMerchantList="merchantList" :fromAgentList="agentList"/>
        </el-tab-pane>

        <el-tab-pane :label="$t('text.settled')" name="settledAmount">
          <PlatformSettled :fromMerchantList="merchantList"/>
        </el-tab-pane>
      </el-tabs>
    </div>
    <recharge-dialog :is-show-recharge-dialog.sync="isShowRechargeDialog"/>
    <credit-dialog :is-show-credit-dialog.sync="isShowCreditDialog"
                   :available-amount="creditAvailableAmount"
                   :granted-amount="creditQuota"/>
    <withdraw-dialog :is-show-withdraw-dialog.sync="isShowWithdrawDialog"
                     :balance="balance"
                     :freezeBalance="freezeBalance"/>
    <AddRechargeWithdrawDialog :isShowAddRechargeWithdrawDialog.sync="isShowAddRechargeWithdrawDialog"
                               :type="addRechargeWithdrawType"
                               :merchantList="merchantList"/>
    <AddTransDialog :isShowAddTransDialog.sync="isShowAddTransDialog"
                    :merchantList="merchantList"/>
  </div>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";
import MerchantRecharge from "./components/MerchantRecharge.vue";
import MerchantWithdraw from "./components/MerchantWithdraw.vue";
import PlatformWaitSettle from "./components/PlatformWaitSettle.vue";
import PlatformSettled from "./components/PlatformSettled.vue";
import PlatformRecharge from "./components/PlatformRecharge.vue";
import PlatformWithdraw from "./components/PlatformWithdraw.vue";
import RechargeDialog from "./components/RechargeDialog.vue";
import WithdrawDialog from "./components/WithdrawDialog.vue";
import AddRechargeWithdrawDialog from "./components/AddRechargeWithdrawDialog.vue";
import AddTransDialog from "./components/AddTransDialog.vue";
import CreditDialog from "@/views/capital/components/CreditDialog.vue";
import MerchantCredit from "@/views/capital/components/MerchantCredit.vue";
import PlatformCredit from "@/views/capital/components/PlatformCredit.vue";
import MerchantReduction from "@/views/capital/components/MerchantReduction.vue";
import PlatformReduction from "@/views/capital/components/PlatformReduction.vue";
import store from "@/store";

export default {
  components: {
    PlatformCredit,
    MerchantCredit,
    MerchantReduction,
    PlatformReduction,
    CreditDialog,
    MerchantRecharge: MerchantRecharge,
    MerchantWithdraw: MerchantWithdraw,
    PlatformWaitSettle: PlatformWaitSettle,
    PlatformSettled: PlatformSettled,
    PlatformRecharge: PlatformRecharge,
    PlatformWithdraw: PlatformWithdraw,
    RechargeDialog: RechargeDialog,
    WithdrawDialog: WithdrawDialog,
    AddRechargeWithdrawDialog,
    AddTransDialog
  },
  data() {
    return {
      ROLE_TYPE,
      activeName: "recharge",
      isShowRechargeDialog: false,
      isShowCreditDialog: false,
      isShowWithdrawDialog: false,
      isShowAddRechargeWithdrawDialog: false,
      isShowAddTransDialog: false,
      addRechargeWithdrawType: "",
      balance: 0,
      freezeBalance: 0,
      waitSettleAmount: 0,
      availableBalance: 0,
      creditQuota: 0,
      creditMerchantCount: 0,
      creditAvailableAmount: 0,

      balanceView: 0,
      freezeBalanceView: 0,
      waitSettleAmountView: 0,
      availableBalanceView: 0,
      creditQuotaView: 0,
      creditMerchantCountView: 0,
      creditAvailableAmountView: 0,
      loading: false,
      merchantList: [],
      agentList: []
    };
  },
  methods: {
    handleRefresh() {
      this.loading = true;
      this.balance = "...";
      this.freezeBalance = "...";
      this.waitSettleAmount = "...";
      this.availableBalance = "...";
      this.creditQuota = "...";
      this.creditMerchantCount = "...";
      this.creditAvailableAmount = "...";

      this.balanceView = "...";
      this.freezeBalanceView = "...";
      this.waitSettleAmountView = "...";
      this.availableBalanceView = "...";
      this.creditQuotaView = "...";
      this.creditMerchantCountView = "...";
      this.creditAvailableAmountView = "...";
      this.axios
          .get("/merchant/getAccountFund", {params: {}})
          .then((res) => {
            if (res.code === 200) {
              this.balance = this.$formatter.FenToYuan(null, null, res.data.balance, null);
              this.balanceView = this.balance.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              this.freezeBalance = this.$formatter.FenToYuan(null, null, res.data.freezeBalance, null);
              this.freezeBalanceView = this.freezeBalance.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              this.waitSettleAmount = this.$formatter.FenToYuan(null, null, res.data.waitSettleAmount,
                  null);
              this.waitSettleAmountView = this.waitSettleAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              this.availableBalance = this.$formatter.FenToYuan(null, null,
                  (res.data.balance - res.data.freezeBalance), null);
              this.availableBalanceView = this.availableBalance.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              this.creditQuota = this.$formatter.FenToYuan(null, null, res.data.creditQuota, null);
              this.creditQuotaView = this.creditQuota.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              this.creditMerchantCount = res.data.creditMerchantCount;
              this.creditMerchantCountView = this.creditMerchantCount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              this.creditAvailableAmount = this.$formatter.FenToYuan(null, null, res.data.creditAvailableAmount,
                  null);
              this.creditAvailableAmountView = this.creditAvailableAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            this.loading = false;
          });
    },
    handleRecharge() {
      this.isShowRechargeDialog = true;
    },
    handleCredit() {
      this.isShowCreditDialog = true;
    },
    handleWithdraw() {
      this.isShowWithdrawDialog = true;
    },
    handleAddRechargeWithdraw(type) {
      this.addRechargeWithdrawType = type;
      this.isShowAddRechargeWithdrawDialog = true;
    },
    handleAddTrans() {
      this.isShowAddTransDialog = true;
    }
  },
  created() {
    this.handleRefresh();
    this.$axios
        .get("/merchant/selectListForOption", {params: {}})
        .then((res) => {
          this.merchantList = res.data;
        });

    if (this.ROLE_TYPE.isManager() || this.ROLE_TYPE.isAgent()) {
      this.$axios
          .get("/agent/selectAgentForOption", {params: {}})
          .then((res) => {
            this.agentList = res.data;
          });
    }
  }
};
</script>
<style lang="scss" scoped>
.colStyle {
  text-align: center;
  line-height: 34px;
}
</style>
